import * as React from 'react';
import { Row as LibRow, RowProps as LibRowProps } from 'react-grid-system';

interface RowProps {
    align?: LibRowProps['align'];
    justify?: LibRowProps['justify'];
    direction?: LibRowProps['direction'];
    wrap?: LibRowProps['wrap'];
    debug?: LibRowProps['debug'];
    style?: LibRowProps['style'];
    nogutter?: LibRowProps['nogutter'];
    component?: LibRowProps['component'];
    gutterWidth?: LibRowProps['gutterWidth'];
    ref?: LibRowProps['ref'];
}

export const Row: React.FunctionComponent<React.PropsWithChildren<RowProps>> = (props) => {
    const { ref, children, ...rest } = props;

    return (
        <LibRow ref={ref as React.LegacyRef<LibRow> & React.LegacyRef<HTMLDivElement>} {...rest}>
            {children}
        </LibRow>
    );
};
